const BYTES_PER_GIGABYTE = 1073741824
const BYTES_PER_MEGABYTE = 1048576
const BYTES_PER_KILOBYTE = 1024

export default function formattedFileSize(bytes: number): string {
  if (bytes >= BYTES_PER_GIGABYTE) {
    return `${trimDecimals(bytes / BYTES_PER_GIGABYTE)} GB`
  } else if (bytes >= BYTES_PER_MEGABYTE) {
    return `${trimDecimals(bytes / BYTES_PER_MEGABYTE)} MB`
  } else if (bytes >= BYTES_PER_KILOBYTE) {
    return `${trimDecimals(bytes / BYTES_PER_KILOBYTE)} kB`
  } else {
    return `${bytes} Byte${bytes === 1 ? '' : 's'}`
  }
}

function trimDecimals(value: number): string {
  return `${parseFloat(value.toFixed(2))}`
}
